import { FormattedMessage } from 'react-intl';
import React from 'react';

export const usersColumns = {
  internalId: {
    id: 'internalId',
    label: <FormattedMessage id={'app.users.internalId'} />,
    width: '60px',
    align: 'right',
  },
  sapId: {
    id: 'idSap',
    label: <FormattedMessage id={'app.users.sapId'} />,
    width: '50px',
    align: 'right',
  },
  role: {
    id: 'role',
    label: <FormattedMessage id={'app.users.role'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '100px',
  },
  organisation: {
    id: 'customersName',
    label: <FormattedMessage id={'app.users.organisation'} />,
    options: {
      sortable: true,
    },
    width: '150px',
  },
  surname: {
    id: 'surname',
    label: <FormattedMessage id={'app.users.surname'} />,
    options: {
      sortable: true,
    },
    width: '80px',
  },
  firstname: {
    id: 'firstname',
    label: <FormattedMessage id={'app.users.firstname'} />,
    options: {
      sortable: true,
    },
    width: '80px',
  },
  email: {
    id: 'email',
    label: <FormattedMessage id={'app.users.email'} />,
    options: {
      sortable: true,
    },
    width: '80px',
  },
  phone: {
    id: 'phone',
    label: <FormattedMessage id={'app.users.phone'} />,
    options: {
      sortable: true,
    },
    width: '80px',
  },
  communicationLanguage: {
    id: 'language',
    label: <FormattedMessage id={'app.users.communicationLanguage'} />,
    options: {
      sortable: true,
    },
    width: '140px',
  },
  state: {
    id: 'state',
    label: <FormattedMessage id={'app.users.state'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '80px',
  },
};
